import Vue from 'vue'

import './styles/quasar.scss'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import {
  Quasar,
  QLayout,
  QHeader,
  QFooter,
  QDrawer,
  QPageContainer,
  QPage,
  QBanner,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QTab,
  QTabs,
  QRouteTab,
  QAvatar,
  QBadge,
  QInput,
  QCard,
  QCardSection,
  QCardActions,
  QSpace,
  QSpinner,
  QSpinnerFacebook,
  QSkeleton,
  Loading,
  Ripple,
  Notify
} from 'quasar'

Vue.use(Quasar, {
  config: {},
  components: {
    QLayout,
    QHeader,
    QFooter,
    QDrawer,
    QPageContainer,
    QPage,
    QBanner,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QTab,
    QTabs,
    QRouteTab,
    QAvatar,
    QBadge,
    QInput,
    QCard,
    QCardSection,
    QCardActions,
    QSpace,
    QSpinner,
    QSpinnerFacebook,
    QSkeleton
  },
  directives: {
    Ripple
  },
  plugins: {
    Loading,
    Notify
  }
})
